import { defineStore } from "pinia";
import Services from '@/services/archiveServices'
import { mapArchive } from '@/helpers/mapFuncs'

export const useArchiveStore = defineStore("archive", {

state:()=>({
    archive: {},
    archives: [],
}),
getters : {
    getArchive() {
        return mapArchive(this.archive)
    },
    getArchives() {
        return this.archives.filter((x)=>x.active).map(mapArchive)
    }
},
actions : {
    /** Start Sets */
    setArchive(archive) {
        this.archive = archive
    },
    setArchives(archives) {
        this.archives = archives
    },
    /** End Sets */

    /** Start Actions */
    getByPersonId(personId) {
        return Services.getByPersonId(personId)
        .then((response)=>{
            this.setArchives(response.data.data)
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.archives.push(response.data.data)
            return mapArchive(response.data.data)
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.archives = this.archives.filter((x)=>x.id != id)
            return mapArchive(response.data.data)
        })
    },
    /** End Actions */
}
});